// The value for the social media option (used for logic in the component)
import {
	REFERRAL_OPTIONS as REFERRAL_OPTIONS_SHARED,
	REFERRAL_NEEDS_EXTRA as REFERRAL_NEEDS_EXTRA_SHARED,
	REFERRAL_EXTRA_LABELS as REFERRAL_EXTRA_LABELS_SHARED,
} from '@leangap/types'

export const REFERRAL_SOCIAL_MEDIA_VALUE = 'Social Media'
export const REFERRAL_OPTIONS = REFERRAL_OPTIONS_SHARED
export const REFERRAL_NEEDS_EXTRA = REFERRAL_NEEDS_EXTRA_SHARED
export const REFERRAL_EXTRA_LABELS = REFERRAL_EXTRA_LABELS_SHARED

export const REFERRAL_SOCIAL_MEDIA_OPTIONS = [
	'Instagram',
	'Facebook',
	'YouTube',
	'Snapchat',
	'TikTok',
] as const

// UI text constants
export const REFERRAL_QUESTION_LABEL = 'How did you hear about Leangap?'
export const REFERRAL_SOCIAL_MEDIA_ARIA = 'Select the social media platform'

// Parents page: how many children select options
export const CHILDREN_SELECT_OPTIONS = [
	{ label: 'Only child', value: 'Only child' },
	{ label: 'Two children', value: 'Two children' },
	{ label: 'More than three', value: 'More than three' },
] as const

// Counselors page: how many students select options
export const COUNSELOR_STUDENTS_SELECT_OPTIONS = [
	{ label: '1-10 students', value: '1-10 students' },
	{ label: '11-50 students', value: '11-50 students' },
	{ label: '51-100 students', value: '51-100 students' },
	{ label: '100+ students', value: '100+ students' },
] as const
